import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "bridgeTo",
    "quantity",
    "value",
    "maxOrder",
    "summaryPair",
    "summaryReceive",
    "summaryPay",
    "summaryInverse",
    "summaryGross",
    "summaryReserve",
    "summaryLocked",
    "summaryOutside",
    "summaryStatus"
  ];

  static values = {
    sourceCoin: String,
    balance: Number,
    toll: Number
  };

  connect() {
    this.render();
  }

  render() {
    const sourceCoin = this.sourceCoinValue || "COIN";
    const targetCoin = this.hasBridgeToTarget ? this.bridgeToTarget.value || "..." : "...";
    const quantity = this.numberValue(this.quantityTarget);
    const rate = this.numberValue(this.valueTarget);
    const maxOrder = this.numberValue(this.maxOrderTarget);
    const reserveMultiplier = maxOrder > 0 ? maxOrder : 1;
    const reserve = reserveMultiplier * this.tollValue;
    const locked = quantity + reserve;
    const outside = this.balanceValue - locked;
    const gross = quantity * rate;
    const inverse = rate > 0 ? 1 / rate : null;

    this.writeText("summaryPair", `${sourceCoin} -> ${targetCoin}`);
    this.writeText("summaryReceive", `${this.format(quantity)} ${sourceCoin}`);
    this.writeText("summaryPay", `${this.format(rate)} ${targetCoin} per 1 ${sourceCoin}`);
    this.writeText("summaryInverse", inverse ? `${this.format(inverse)} ${sourceCoin} per 1 ${targetCoin}` : "rate pending");
    this.writeText("summaryGross", `${this.format(gross)} ${targetCoin}`);
    this.writeText("summaryReserve", `${this.format(reserve)} ${sourceCoin}`);
    this.writeText("summaryLocked", `${this.format(locked)} ${sourceCoin}`);
    this.writeText("summaryOutside", `${this.format(outside)} ${sourceCoin}`);

    let status = `${sourceCoin} is the inventory lane. ${targetCoin} is what the buyer sends first.`;
    if (!quantity || !rate) {
      status = "Set the listed inventory and the buyer-side rate to see how the storefront locks inventory.";
    } else if (outside < 0) {
      status = `This storefront currently overcommits your wallet by ${this.format(Math.abs(outside))} ${sourceCoin}. Reduce inventory or max fills.`;
    } else if (maxOrder > 0) {
      status = `This bridge will preload toll reserve for ${this.format(maxOrder, 0)} fills and leave ${this.format(outside)} ${sourceCoin} outside the storefront.`;
    } else {
      status = `This bridge keeps one fill's toll reserve on standby and leaves ${this.format(outside)} ${sourceCoin} outside the storefront.`;
    }

    this.writeText("summaryStatus", status);
  }

  writeText(targetName, text) {
    const target = this[`${targetName}Target`];
    if (target) target.textContent = text;
  }

  numberValue(target) {
    if (!target) return 0;
    const value = parseFloat(target.value);
    return Number.isFinite(value) ? value : 0;
  }

  format(value, precision = 8) {
    const numeric = Number.isFinite(value) ? value : 0;
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: precision
    }).format(numeric);
  }
}
